import { useNavigate } from 'react-router-dom';
import { PrimeIcons } from 'primereact/api';
import { Column, Checkbox } from '../../../../components/PrimereactComponents';
import { PaginatedDataTable } from '../../../components/PaginatedDataTable';
import { ButtonAdd, ButtonDownload, ButtonEdit } from '../../../components/Buttons';

export const DatabaseTable = ({
	databases,
    onClickExportDatabase,
    onClickEditDatabase,
    onClickShowBackups,
    onChangeRowCheckbox,
    onChangeHeaderCheckbox,
    rowCheckboxSelected,
    headerCheckboxSelected,
    selectAllCheckbox,
	loading,
    disabled
}) => {
	const navigate = useNavigate();

	const highlightRow = (rowData) => {
        return {
            'table-row--bold': true,
            'table-row--deleted': rowData.deleted
        };
    };

    const databaseCheckboxBodyTemplate = (rowData) => {
        return (
            <div
                // This hack ensures that row click event doesn't trigger when row checkbox is being clicked.
                // It was the only way I managed to make it work properly.
                onClick={(e) => e.stopPropagation()}
            >
                <Checkbox
                    name='rowCheckbox'
                    checked={rowCheckboxSelected(rowData)}
                    disabled={rowData.deleted}
                    onChange={() => onChangeRowCheckbox(rowData)}
                />
            </div>
        );
    };

    const databaseCheckboxHeaderTemplate = () => {
        return (
            <Checkbox
                name='headerCheckbox'
                checked={headerCheckboxSelected}
                onChange={() => onChangeHeaderCheckbox()}
            />
        );
    }

    const databaseButtonsTemplate = (rowData) => {
        return (
            <div className='table-buttons'>
                <ButtonAdd
                    rounded
                    title='Zobrazit zálohy'
                    disabled={disabled}
                    onClick={() => onClickShowBackups(rowData)}
                    icon={PrimeIcons.BOOKMARK}
                />

                <ButtonDownload
                    rounded
                    title='Exportovat databázi'
                    disabled={disabled || rowData.deleted}
                    onClick={() => onClickExportDatabase(rowData)}
                />

                <ButtonEdit
                    rounded
                    title='Editovat databázi'
                    disabled={disabled || rowData.deleted}
                    onClick={() => onClickEditDatabase(rowData)}
                />
            </div>
        );
    };

    const handleRowClick = (event) => {
        const database = event.data
        if (database.deleted) return;
        onChangeRowCheckbox(event.data);
    };

	return (
		<PaginatedDataTable
            value={databases}
            loading={loading}
            removableSort
            initialRows={25}
            rowsPerPageOptions={[10, 25, 50, 100]}
            breakpoint='900px'
            emptyMessage='Nebyly nalezeny žádné databáze'
            rowHover
            rowClassName={highlightRow}
            onRowClick={handleRowClick}
            dataKey='id'
        >
            <Column field='database_checkbox' header={databaseCheckboxHeaderTemplate} body={databaseCheckboxBodyTemplate} align='center' />
            <Column field='name' header='Název' sortable />
            <Column field='type_name' header='Typ' sortable />
            <Column field='last_changed' header='Poslední změna' />
            <Column field='last_backup' header='Poslední záloha' />
            <Column body={databaseButtonsTemplate} align='right' />
        </PaginatedDataTable>
	);
};
